import React from "react";
import "./scss/main.scss";
import Register from "./components/Register";

function App() {
    return (
        <div className="fixed pin w-screen h-screen flex items-center justify-center z-20  flex-col">
            <div className="absolute w-full h-full">
                <img src="https://cdn.shippify.co/dash/src/saas-signup/image/RouteBackground.svg" alt="" className="object-cover h-full w-full" style={{ filter: "brightness(0.75)" }} />
            </div>
            <div className="rounded z-40 w-modal max-w-xl bg-white flex flex-col p-4 border shadow-2xl">
                <Register />
            </div>
        </div>
    );
}

export default App;
